module.exports = __webpack_public_path__ + "img/expand_less-black-24dp.16c55acc.svg";